module.exports = __webpack_public_path__ + "images/762aebd574534566e2812ed583b01310.jpg";